import Dexie, { type Table } from 'dexie';

interface CachedAudio {
  key: string;
  blob: Blob;
  updatedAt: number;
}

class BankAudioCacheDatabase extends Dexie {
  audio!: Table<CachedAudio>;

  constructor() {
    super('ExamFlowBankAudioCache');
    this.version(1).stores({ audio: 'key, updatedAt' });
  }
}

const db = new BankAudioCacheDatabase();

export const bankAudioCache = {
  get(key: string): Promise<CachedAudio | undefined> {
    return db.audio.get(key);
  },
  async put(key: string, blob: Blob): Promise<void> {
    await db.audio.put({ key, blob, updatedAt: Date.now() });
  },
  deleteByQuestionIds(questionIds: string[]): Promise<void> {
    return db.transaction('rw', db.audio, async () => {
      const all = await db.audio.toArray();
      await db.audio.bulkDelete(
        all.filter((entry) => questionIds.some((id) => entry.key.startsWith(`${id}:`))).map((entry) => entry.key)
      );
    });
  },
};
